import type { DynamicPropertyValueType, Property, InputDynamicPropertyValueType } from "@/core/api/graphql/types";

interface HasNameAndValue {
  name?: string;
  value?: unknown;
}
export function getDynamicPropertyValue<T = unknown>(
  obj: HasNameAndValue[] | undefined,
  dynamicProperty: string,
): T | undefined {
  if (!obj) return undefined;

  const targetObject = obj.find((item) => item.name === dynamicProperty);

  return targetObject?.value as T | undefined;
}

export function updateDynamicProperties(
  propName: string,
  propValue: string | number,
  dynamicProperties: InputDynamicPropertyValueType[],
) {
  const newProperty = [{ name: propName, value: propValue }];

  dynamicProperties = dynamicProperties.map((existingObj) => {
    const updatedObject = newProperty.find((newObj) => newObj.name === existingObj.name);
    return updatedObject ? updatedObject : existingObj;
  });
  newProperty.forEach((newObj) => {
    if (!dynamicProperties.some((existingObj) => existingObj.name === newObj.name)) {
      dynamicProperties.push(newObj);
    }
  });

  return dynamicProperties;
}

// Innovadis custom function
export function highlightSearchPhrase(text: string | undefined, searchPhrase?: string): string {
  // Return empty string when no text provided
  if (!text) {
    return "";
  }

  // Return the original text if no search phrase is provided
  if (!searchPhrase) {
    return text;
  }
  const escapedSearchPhrase = searchPhrase.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // Escape special characters
  const regex = new RegExp(escapedSearchPhrase, "gi"); // Case-insensitive search
  return text.replace(
    regex,
    (match) => `<span class="font-bold text-[color:var(--color-secondary-500)]">${match}</span>`,
  );
}
